"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var querystringify_1 = __importDefault(require("querystringify"));
var url_parse_1 = __importDefault(require("url-parse"));
var index_1 = require("./util/index");
exports.getUrl = function () {
    if (index_1.isWeex()) {
        return weex.config.bundleUrl;
    }
    else if (index_1.isWxMp()) {
        return '';
    }
    else {
        if (typeof window === 'object' && window.location) {
            return window.location.href;
        }
        else {
            throw new Error('Not Support Enviroment!');
        }
    }
};
exports.parse = function (url) {
    var originUrl = url || exports.getUrl();
    var urlObj = new url_parse_1.default(originUrl, true);
    var href = urlObj.href, protocol = urlObj.protocol, origin = urlObj.origin, host = urlObj.host, hostname = urlObj.hostname, port = urlObj.port, pathname = urlObj.pathname, query = urlObj.query, hash = urlObj.hash, username = urlObj.username, password = urlObj.password;
    var search = querystringify_1.default.stringify(query);
    return {
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        password: password,
        pathname: pathname,
        port: port,
        protocol: protocol,
        query: query,
        search: search,
        username: username,
    };
};
function getQuery(name, url) {
    var href;
    if (name && url) {
        href = url;
    }
    else if (!name && url) {
        href = url;
    }
    else {
        href = exports.getUrl();
    }
    var parsedUrl = exports.parse(href);
    if (name) {
        if (parsedUrl.query) {
            return parsedUrl.query[name];
        }
        else {
            return undefined;
        }
    }
    else {
        return parsedUrl.query;
    }
}
exports.getQuery = getQuery;
exports.setQuery = function (url, name, value) {
    if (!url || !name || !value) {
        throw new Error('lack of param');
    }
    var urlObj = new url_parse_1.default(url, true);
    var newQuery = urlObj.query;
    if (newQuery && !Array.isArray(newQuery)) {
        newQuery[name] = value;
        urlObj.set('query', newQuery);
    }
    return urlObj.href;
};
exports.removeQuery = function (url, name) {
    if (!url || !name) {
        throw new Error('lack of param');
    }
    var urlObj = new url_parse_1.default(url, true);
    var newQuery = urlObj.query;
    if (newQuery && !Array.isArray(newQuery)) {
        delete newQuery[name];
        urlObj.set('query', newQuery);
    }
    return urlObj.href;
};
exports.appendQuery = function (url, query) {
    if (!url) {
        throw new Error('lack of param');
    }
    var urlObj = new url_parse_1.default(url, true);
    var newQuery = urlObj.query;
    if (newQuery && !Array.isArray(newQuery) && query && !Array.isArray(query)) {
        newQuery = __assign({}, newQuery, query);
        urlObj.set('query', newQuery);
    }
    return urlObj.href;
};
